import { HStack, StackItem } from "@/components/Elements/Layouts/Stack";
import { adminState } from "@/store/adminState";
import { Container } from "@mui/material";
import { useRecoilState } from "recoil";
import { Edit } from "./components/Edit";
import { Login } from "./components/Login";

export const AdminLogin = () => {
  const [admin] = useRecoilState(adminState);

  if (!admin.doneLogin) {
    return (
      <HStack>
        <StackItem flex>
          <Container maxWidth="sm">
            <Login />
          </Container>
        </StackItem>
      </HStack>
    );
  }
  return <Edit />;
};
